import type { ChatRequest, ChatResponse } from "./types";

/**
 * Mock chat responses per modalità demo / fallback.
 * Tono tecnico, diretto, prudente. Niente formule promozionali.
 */

const SUGGESTIONS_MODELS = [
  "Hub (2G)/(4G) Jeweller",
  "Superior Hub Hybrid 2",
  "D7021",
  "D7022",
];

function delay(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}

function match(text: string, ...keywords: string[]): boolean {
  const t = text.toLowerCase();
  return keywords.every((k) => t.includes(k.toLowerCase()));
}

function any(text: string, ...keywords: string[]): boolean {
  const t = text.toLowerCase();
  return keywords.some((k) => t.includes(k.toLowerCase()));
}

export async function mockChat(req: ChatRequest): Promise<ChatResponse> {
  await delay(700 + Math.random() * 600);
  const q = req.message;

  // 1) Superior Hub Hybrid 2 — linee Fibra
  if (match(q, "superior hub hybrid 2") && any(q, "fibra", "linee")) {
    return {
      answer: "Superior Hub Hybrid 2 ha 8 linee Fibra.",
      source: "Manuale utente Superior Hub Hybrid 2",
      note: "Nessuna nota aggiuntiva.",
      status: "ok",
      fromMock: true,
    };
  }

  // 2) D7021 — pannelli fotovoltaici
  if (match(q, "d7021") && any(q, "fotovolta", "pannell", "solare", "alimenta")) {
    return {
      answer:
        "Sì. La centralina D7021 può essere alimentata tramite trasformatore oppure tramite uno o più pannelli fotovoltaici.",
      source:
        "Centralina elettronica universale Solarmatic D7021 I — Manuale generale d'installazione e programmazione",
      note: "Nessuna nota aggiuntiva.",
      status: "ok",
      fromMock: true,
    };
  }

  // 3) Sirena esterna Hub Jeweller — not_found
  if (any(q, "sirena") && any(q, "hub", "jeweller")) {
    return {
      answer: "Informazione non trovata nei manuali disponibili.",
      source: "Manuali recuperati nelle citazioni; dato non presente nei frammenti disponibili.",
      note: "Serve uno schema o un manuale specifico che riporti esplicitamente i morsetti.",
      status: "not_found",
      fromMock: true,
    };
  }

  // 4) Connettore alimentazione Hub Jeweller (numero)
  if (any(q, "hub", "jeweller") && any(q, "alimentazione", "connettore", "presa") && any(q, "numero", "indica")) {
    return {
      answer:
        "Nella sezione Elementi funzionali, la presa del cavo di alimentazione è indicata con il numero 3. Nella figura di installazione/connettori, il connettore per il cavo di alimentazione è indicato con il numero 1.",
      source: "Manuale utente Hub (2G) / (4G) Jeweller",
      note: "Le numerazioni si riferiscono a figure/sezioni diverse del manuale.",
      status: "ok",
      fromMock: true,
    };
  }

  // 5) Tamper Hub Jeweller
  if (any(q, "hub", "jeweller") && any(q, "tamper", "antisabotaggio") && any(q, "numero", "indica")) {
    return {
      answer: "Il tamper antisabotaggio è indicato con il numero 7.",
      source: "Manuale utente Hub (2G) / (4G) Jeweller",
      note: "Nessuna nota aggiuntiva.",
      status: "ok",
      fromMock: true,
    };
  }

  // 6) Morsetti motore D7021 — not_found
  if (any(q, "d7021") && any(q, "morsett") && any(q, "motore")) {
    return {
      answer: "Informazione non trovata nei manuali disponibili.",
      source: "Manuali recuperati nelle citazioni; dato non presente nei frammenti disponibili.",
      note: "Per rispondere serve uno schema morsettiera esplicito del modello D7021.",
      status: "not_found",
      fromMock: true,
    };
  }

  // 7) Tamper generico (senza modello)
  if (any(q, "tamper", "antisabotaggio") && !any(q, "hub", "d70", "jeweller", "hybrid")) {
    return {
      answer: "Per quale modello esatto vuoi questa informazione?",
      note: "Indica il modello del dispositivo o della centralina per cercare il manuale corretto.",
      status: "clarification",
      suggestions: SUGGESTIONS_MODELS,
      fromMock: true,
    };
  }

  // 8) Morsetti generici senza modello
  if (any(q, "morsett") && !any(q, "hub", "d70", "jeweller", "hybrid")) {
    return {
      answer: "Per quale modello esatto vuoi questa informazione?",
      note: "Indica il dispositivo per cui vuoi lo schema morsettiera.",
      status: "clarification",
      suggestions: SUGGESTIONS_MODELS,
      fromMock: true,
    };
  }

  // 9) Schema/figura
  if (any(q, "schema", "figura", "disegno")) {
    return {
      answer: "Per quale modello esatto vuoi cercare lo schema o la figura?",
      note: "Specifica il dispositivo per individuare la pagina e la figura corrette nel manuale.",
      status: "clarification",
      suggestions: SUGGESTIONS_MODELS,
      fromMock: true,
    };
  }

  // 10) Alimentazione generica
  if (any(q, "alimenta", "alimentazione", "collego", "collegare") && !any(q, "d70", "hub", "jeweller", "hybrid")) {
    return {
      answer: "Per quale modello esatto vuoi questa informazione?",
      note: "Indica il modello del dispositivo o della centralina per cercare il manuale corretto.",
      status: "clarification",
      suggestions: SUGGESTIONS_MODELS,
      fromMock: true,
    };
  }

  // Default: chiarimento
  return {
    answer: "Per quale modello esatto vuoi questa informazione?",
    note: "Indica il modello del dispositivo per cercare il manuale corretto.",
    status: "clarification",
    suggestions: SUGGESTIONS_MODELS,
    fromMock: true,
  };
}